"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/external-bank.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fexternal-bank.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.bankProviderToJSON = exports.bankProviderFromJSON = exports.externalBankStatusToJSON = exports.externalBankStatusFromJSON = exports.BankDescriptor = exports.ExternalBank = exports.BankProvider = exports.ExternalBankStatus = void 0;
const ach_account_1 = require("./ach-account");
const ach_account_balance_1 = require("./ach-account-balance");
const protobufPackage = 'com.step.common.proto';
/**
 * Verification status.
 */
var ExternalBankStatus;
(function (ExternalBankStatus) {
    ExternalBankStatus["INVALID_STATUS"] = "INVALID_STATUS";
    ExternalBankStatus["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
    ExternalBankStatus["FAILED_VERIFICATION"] = "FAILED_VERIFICATION";
    ExternalBankStatus["VERIFIED"] = "VERIFIED";
    ExternalBankStatus["EXPIRED"] = "EXPIRED";
    ExternalBankStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ExternalBankStatus || (exports.ExternalBankStatus = ExternalBankStatus = {}));
/**
 * Providers responsible for linking, tokenizing, and storing ACH account information.
 */
var BankProvider;
(function (BankProvider) {
    BankProvider["INVALID_BANK_PROVIDER"] = "INVALID_BANK_PROVIDER";
    BankProvider["STEP"] = "STEP";
    BankProvider["PLAID"] = "PLAID";
    BankProvider["UNRECOGNIZED"] = "UNRECOGNIZED";
})(BankProvider || (exports.BankProvider = BankProvider = {}));
function createBaseExternalBank() {
    return {
        status: ExternalBankStatus.INVALID_STATUS,
        linkingReferenceId: '',
        tokenReferenceId: '',
        linkingProvider: BankProvider.INVALID_BANK_PROVIDER,
        bank: undefined,
        routingNumber: '',
        maskedAccountNumber: '',
        accountType: ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE,
        cachedBalance: undefined,
        accountHolderName: '',
        bankName: '',
        bankLogo: '',
        syntheticId: '',
    };
}
exports.ExternalBank = {
    fromJSON(object) {
        const message = {
            status: isSet(object.status)
                ? externalBankStatusFromJSON(object.status)
                : ExternalBankStatus.INVALID_STATUS,
            linkingProvider: isSet(object.linkingProvider)
                ? bankProviderFromJSON(object.linkingProvider)
                : BankProvider.INVALID_BANK_PROVIDER,
        };
        if (isSet(object.linkingReferenceId)) {
            message.linkingReferenceId = globalThis.String(object.linkingReferenceId);
        }
        if (isSet(object.tokenReferenceId)) {
            message.tokenReferenceId = globalThis.String(object.tokenReferenceId);
        }
        if (isSet(object.bank)) {
            message.bank = exports.BankDescriptor.fromJSON(object.bank);
        }
        if (isSet(object.routingNumber)) {
            message.routingNumber = globalThis.String(object.routingNumber);
        }
        if (isSet(object.maskedAccountNumber)) {
            message.maskedAccountNumber = globalThis.String(object.maskedAccountNumber);
        }
        if (isSet(object.accountType)) {
            message.accountType = (0, ach_account_1.achAccountTypeFromJSON)(object.accountType);
        }
        if (isSet(object.cachedBalance)) {
            message.cachedBalance = ach_account_balance_1.AchAccountBalance.fromJSON(object.cachedBalance);
        }
        if (isSet(object.accountHolderName)) {
            message.accountHolderName = globalThis.String(object.accountHolderName);
        }
        if (isSet(object.bankName)) {
            message.bankName = globalThis.String(object.bankName);
        }
        if (isSet(object.bankLogo)) {
            message.bankLogo = globalThis.String(object.bankLogo);
        }
        if (isSet(object.syntheticId)) {
            message.syntheticId = globalThis.String(object.syntheticId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== ExternalBankStatus.INVALID_STATUS) {
            obj.status = externalBankStatusToJSON(message.status);
        }
        if (message.linkingReferenceId !== undefined && message.linkingReferenceId !== '') {
            obj.linkingReferenceId = message.linkingReferenceId;
        }
        if (message.tokenReferenceId !== undefined && message.tokenReferenceId !== '') {
            obj.tokenReferenceId = message.tokenReferenceId;
        }
        if (message.linkingProvider !== BankProvider.INVALID_BANK_PROVIDER) {
            obj.linkingProvider = bankProviderToJSON(message.linkingProvider);
        }
        if (message.bank !== undefined) {
            obj.bank = exports.BankDescriptor.toJSON(message.bank);
        }
        if (message.routingNumber !== undefined && message.routingNumber !== '') {
            obj.routingNumber = message.routingNumber;
        }
        if (message.maskedAccountNumber !== undefined && message.maskedAccountNumber !== '') {
            obj.maskedAccountNumber = message.maskedAccountNumber;
        }
        if (message.accountType !== undefined &&
            message.accountType !== ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE) {
            obj.accountType = (0, ach_account_1.achAccountTypeToJSON)(message.accountType);
        }
        if (message.cachedBalance !== undefined) {
            obj.cachedBalance = ach_account_balance_1.AchAccountBalance.toJSON(message.cachedBalance);
        }
        if (message.accountHolderName !== undefined && message.accountHolderName !== '') {
            obj.accountHolderName = message.accountHolderName;
        }
        if (message.bankName !== undefined && message.bankName !== '') {
            obj.bankName = message.bankName;
        }
        if (message.bankLogo !== undefined && message.bankLogo !== '') {
            obj.bankLogo = message.bankLogo;
        }
        if (message.syntheticId !== undefined && message.syntheticId !== '') {
            obj.syntheticId = message.syntheticId;
        }
        return obj;
    },
    create(base) {
        return exports.ExternalBank.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseExternalBank();
        message.status = object.status ?? ExternalBankStatus.INVALID_STATUS;
        message.linkingReferenceId = object.linkingReferenceId ?? '';
        message.tokenReferenceId = object.tokenReferenceId ?? '';
        message.linkingProvider = object.linkingProvider ?? BankProvider.INVALID_BANK_PROVIDER;
        message.bank = (object.bank !== undefined && object.bank !== null)
            ? exports.BankDescriptor.fromPartial(object.bank)
            : undefined;
        message.routingNumber = object.routingNumber ?? '';
        message.maskedAccountNumber = object.maskedAccountNumber ?? '';
        message.accountType = object.accountType ?? ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE;
        message.cachedBalance = (object.cachedBalance !== undefined && object.cachedBalance !== null)
            ? ach_account_balance_1.AchAccountBalance.fromPartial(object.cachedBalance)
            : undefined;
        message.accountHolderName = object.accountHolderName ?? '';
        message.bankName = object.bankName ?? '';
        message.bankLogo = object.bankLogo ?? '';
        message.syntheticId = object.syntheticId ?? '';
        return message;
    },
};
function createBaseBankDescriptor() {
    return { name: '', logoUrl: '', primaryColor: '', referenceId: '' };
}
exports.BankDescriptor = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.name)) {
            message.name = globalThis.String(object.name);
        }
        if (isSet(object.logoUrl)) {
            message.logoUrl = globalThis.String(object.logoUrl);
        }
        if (isSet(object.primaryColor)) {
            message.primaryColor = globalThis.String(object.primaryColor);
        }
        if (isSet(object.referenceId)) {
            message.referenceId = globalThis.String(object.referenceId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== undefined && message.name !== '') {
            obj.name = message.name;
        }
        if (message.logoUrl !== undefined && message.logoUrl !== '') {
            obj.logoUrl = message.logoUrl;
        }
        if (message.primaryColor !== undefined && message.primaryColor !== '') {
            obj.primaryColor = message.primaryColor;
        }
        if (message.referenceId !== undefined && message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        return obj;
    },
    create(base) {
        return exports.BankDescriptor.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBankDescriptor();
        message.name = object.name ?? '';
        message.logoUrl = object.logoUrl ?? '';
        message.primaryColor = object.primaryColor ?? '';
        message.referenceId = object.referenceId ?? '';
        return message;
    },
};
function externalBankStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_STATUS':
            return ExternalBankStatus.INVALID_STATUS;
        case 1:
        case 'PENDING_VERIFICATION':
            return ExternalBankStatus.PENDING_VERIFICATION;
        case 2:
        case 'FAILED_VERIFICATION':
            return ExternalBankStatus.FAILED_VERIFICATION;
        case 3:
        case 'VERIFIED':
            return ExternalBankStatus.VERIFIED;
        case 4:
        case 'EXPIRED':
            return ExternalBankStatus.EXPIRED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ExternalBankStatus.UNRECOGNIZED;
    }
}
exports.externalBankStatusFromJSON = externalBankStatusFromJSON;
function externalBankStatusToJSON(object) {
    switch (object) {
        case ExternalBankStatus.INVALID_STATUS:
            return 'INVALID_STATUS';
        case ExternalBankStatus.PENDING_VERIFICATION:
            return 'PENDING_VERIFICATION';
        case ExternalBankStatus.FAILED_VERIFICATION:
            return 'FAILED_VERIFICATION';
        case ExternalBankStatus.VERIFIED:
            return 'VERIFIED';
        case ExternalBankStatus.EXPIRED:
            return 'EXPIRED';
        case ExternalBankStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.externalBankStatusToJSON = externalBankStatusToJSON;
function bankProviderFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_BANK_PROVIDER':
            return BankProvider.INVALID_BANK_PROVIDER;
        case 1:
        case 'STEP':
            return BankProvider.STEP;
        case 2:
        case 'PLAID':
            return BankProvider.PLAID;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return BankProvider.UNRECOGNIZED;
    }
}
exports.bankProviderFromJSON = bankProviderFromJSON;
function bankProviderToJSON(object) {
    switch (object) {
        case BankProvider.INVALID_BANK_PROVIDER:
            return 'INVALID_BANK_PROVIDER';
        case BankProvider.STEP:
            return 'STEP';
        case BankProvider.PLAID:
            return 'PLAID';
        case BankProvider.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.bankProviderToJSON = bankProviderToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=external-bank.js.map